module.exports = __webpack_public_path__ + "assets/img/baoche4.7bfcdf09.png";